export default __webpack_public_path__ + "static/hero-mobile-abd71162258a6c48d4fd7857d071cd7f.png";